import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class ShareCapitalCriteria extends Model.CriteriaBase {
    static typeName = "ShareCapitalCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.monthEnd(DateUtils.today());

    public showLinkedOnly: boolean = false;

    public showRedeemed: boolean = false;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<ShareCapitalCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Share Capital Criteria";
    }
}